const config =  {
  download(reportName, formattedResponse, columns) {
    let csv = '';    
    for (const key in columns) {
      csv += '"'+ columns[key].label + '",';
    }
    csv += "\n";
    formattedResponse.forEach(function(row) {
      let value = '';
      for (const key in columns) {
        value = row[key] ? row[key] : '';
        csv += '"'+ value + '",';
      }
      csv += "\n";
    });
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = reportName + '-' + this.getFormattedTime() + '.csv';
    hiddenElement.click();
  },
  getFormattedTime() {
    var today = new Date();
    var y = today.getFullYear();
    // JavaScript months are 0-based.
    var m = today.getMonth() + 1;
    var d = today.getDate();
    var h = today.getHours();
    var mi = today.getMinutes();
    var s = today.getSeconds();
    return y + "-" + m + "-" + d + "-" + h + "-" + mi;
  }
};

export default config;
